<template>
  <div class="productSort"   >>
    <form @submit.prevent="submitForm">
      <div class="header acea-row row-center-wrapper" ref="header">
        <div class="acea-row row-between-wrapper input">
          <span class="iconfont icon-sousuo"></span>
          <input type="text" placeholder="搜索商品信息" v-model="search" />
        </div>
      </div>
    </form>
    <div class="aside">
      <div
        class="item acea-row row-center-wrapper"
        :class="index === navActive ? 'on' : ''"
        v-for="(item, index) in category"
        :key="index"
        @click="asideTap(index)"
      >
        <span>{{ item.cateName }}</span>
      </div>
    </div>
    <div class="recommend" @scroll.native="onScroll" ref="container">
    <div class="conter" >
      <div class="listw" v-for="(item, index) in categoryList" :key="index">
        <div class="title acea-row row-center-wrapper" ref="title">
          <div class="line"></div>
          <div class="name">{{ item.cateName }}</div>
          <div class="line"></div>
        </div>

        <div class="recommendList acea-row row-between-wrapper">
          <router-link
                  :to="{ path: '/detail/' + item.id }"
                  class="item1"
                  v-for="(item, index) in productList"
                  :key="index"
          >
            <div class="pictrue1">
              <img :src="item.image" class="image" />
            </div>
            <div class="name line1">{{ item.storeName }}</div>
            <div class="money font-color-red">
              ￥<span class="num">{{ item.price }}</span>
            </div>
          </router-link>
        </div>

      <!--  <div class="list acea-row">
          <router-link
            class="item acea-row row-column row-middle"
            v-for="(child, index) in item.children"
            :key="index"
            :to="{
              path: '/goods_list',
              query: { id: child.id, title: child }
            }"
          >
            <div class="picture"><img :src="child.pic" /></div>
            <div class="name line1">{{ child.cateName }}</div>
          </router-link>
        </div>-->
      </div>
      <Loading :loaded="loadend" :loading="loading"></Loading>
    </div>
    </div>
  </div>
</template>
<script>
import $store from "../../store";
import { getHuaweiCategory,getProducts } from "@api/store";
import { trim } from "../../utils";
import debounce from "lodash.debounce";
import Loading from "@components/Loading";

export default {
  name: "HuaweiClass",
   components: {
        Loading
    },
  props: {},
  data: function() {
    return {
      category: [],
     categoryList:[],
      productList: [],
      navActive: 0,
      index:0,
      search: "",
      lock: false,
      loading: false,
        loadend: false,
        where: {
            page: 1,
            limit: 8,
            sid: '', //二级分类id
            news: 0,
            priceOrder: "",
            salesOrder: "",
            deptId:$store.state.app.deptId
        },
    };
  },
  watch: {
    "$route.params.pid": function(n) {
      console.log(n);
      if (n) {
        this.activeCateId(n);
      }
    }
  },
  mounted: function() {
    document.addEventListener("scroll", this.onScroll, false);
    this.loadCategoryData();
    this.get_product_list(0);
      this.$scroll(this.$refs.container, () => {
          !this.loading && this.get_product_list(0);
      });

  },
  methods: {
    activeCateId(n) {
      let index = 0;
      n = parseInt(n);
      if (!n) return;
      this.category.forEach((cate, i) => {
        if (cate.id === n) index = i;
      });

      if (index !== this.navActive) {
        this.asideTap(index);
      }
    },
    loadCategoryData() {
        getHuaweiCategory().then(res => {
          this.category = res.data;
          this.categoryList.push(this.category[0]);
        this.$nextTick(() => {
          if (this.$route.params.pid) this.activeCateId(this.$route.params.pid);
          else this.onScroll();
        });
      });
    },
      get_product_list: debounce(function(index) {
          var that = this;
          if (that.loading) return;
          if (that.loadend) return;
          that.loading = true;
          that.setWhere(index);
          let q = that.where;
          getProducts(q).then(res => {
              that.loading = false;
              that.productList.push.apply(that.productList, res.data);
              that.loadend = res.data.length < that.where.limit; //判断所有数据是否加载完成；
              that.where.page = that.where.page + 1;
          });
      }, 300),
    submitForm: function() {
      var val = trim(this.search);
      if (val) {
        this.$router.push({
          path: "/goods_list",
          query: { s: val }
        });
        setTimeout(() => (this.search = ""), 500);
      }
    },
    asideTap(index) {
        this.categoryList=[];
        this.productList=[];
        this.loadend=false;
        this.where.page =1;
        this.categoryList.push(this.category[index]);
        this.get_product_list(index);
        this.$scroll(this.$refs.container, () => {
            !this.loading && this.get_product_list(index);
        });
        const top =
           60 -
            this.$refs.header.offsetHeight -
            window.scrollY;

        this.lock = true;

        window.scrollBy({ top, left: 0, behavior: "smooth" });
        this.navActive = index;
    },
    onScroll: debounce(function() {
      if (this.lock) {
        this.lock = false;
        return;
      }
      const headerHeight = this.$refs.header.offsetHeight,
        { scrollY } = window,
        titles = this.$refs.title;
      titles.reduce((initial, title, index) => {
        if (initial) return initial;
        const parent = title.parentNode || title.parentElement;
        if (
          scrollY + headerHeight + 15 <
          title.offsetTop + parent.offsetHeight
        ) {
          initial = true;
          this.navActive = index;
        }
        return initial;
      }, false);
    }, 500),
      //设置where条件
      setWhere: function(index) {
          let that = this;
              that.where.sid =that.category[index].id;

      }
  },
  beforeDestroy: function() {
    document.removeEventListener("scroll", this.onScroll, false);
  }
};
</script>
